import { getHumanTimePeriod, isRunning } from '@app/logic/deliveryWindows';
import { cn } from '@app/utils/cn';
import { isDefined, isNull } from '@app/utils/is';
import { DeliveryWindow } from '@typings';
import cx from 'classnames';
import React from 'react';

import { Calendar, PreorderWithDates, Stock, StockWithDates } from '../Icons';
import { Tooltip } from '../Tooltip';

import { TooltipContent } from './TooltipContent';

interface Props {
  deliveryWindow: DeliveryWindow.Mixed;
  insertCommas?: boolean;
  iconClassName?: string;
  shouldStretch?: boolean;
}

const preventDefault = (evt: React.UIEvent) => {
  evt.stopPropagation();
  evt.preventDefault();
};

export const DelwinNameAndDate = ({
  deliveryWindow,
  insertCommas = false,
  iconClassName,
  shouldStretch,
  children,
}: React.WithOptionalChildren<Props>) => {
  const { deliveryPeriod } = getHumanTimePeriod(deliveryWindow);

  const Icon = React.useMemo(() => {
    if (isRunning(deliveryWindow) || isNull(deliveryPeriod)) {
      return deliveryWindow.stockType === 'stock' ? Stock : Calendar;
    }

    return deliveryWindow.stockType === 'stock' ? StockWithDates : PreorderWithDates;
  }, [deliveryPeriod, deliveryWindow]);

  return (
    <span
      className={cx('flex items-center overflow-hidden', {
        'min-h-[19px] w-full justify-between': shouldStretch,
        'pl-1 [&:not(:last-child)]:after:content-[","]': insertCommas,
      })}
    >
      {isDefined(children) ? children : <span className="overflow-hidden text-ellipsis body-2">{deliveryWindow.name}</span>}
      <Tooltip content={<TooltipContent deliveryWindow={deliveryWindow} />}>
        <span
          className={cn(
            'ml-1 mr-0.5 inline-flex cursor-pointer items-center',
            {
              'mr-0': insertCommas,
              'mr-0.5': shouldStretch,
            },
            iconClassName,
          )}
          role="presentation"
          onClick={preventDefault}
        >
          <Icon />
        </span>
      </Tooltip>
    </span>
  );
};
